// SINGLE source of user-facing role labels. Internal role VALUES are
// unchanged (`location` stays `location` in the DB, the JWT and every
// require_roles call) — this map only controls what a human reads.
// No surface may render a raw role value.
export const ROLE_LABELS = {
  admin: "Admin",
  sales: "Sales",
  collections: "Collections",
  location: "WS Location",
  clinic: "Clinic",
  partner: "Referral Partner",
  FIRM_ADMIN: "Firm Admin",
  FIRM_USER: "Firm User",
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || "";
